import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
import { lastValueFrom, Observable, Subject } from 'rxjs';
import { debounceTime, switchMap, takeUntil } from 'rxjs/operators';
import { CaminhosModalComponent } from 'src/app/components/caminhos-modal/caminhos-modal.component';
import { CategoryModel } from 'src/app/models/Category.model';
import { CIStructuredNewsModel } from 'src/app/models/CIStructuredNews.model';
import { EditorialModel } from 'src/app/models/Editorial.model';
import { NewsFilterModel, NewsModel } from 'src/app/models/News.model';
import { CIService } from 'src/app/services/CI/ci.service';
import { NewsService } from 'src/app/services/News/news.service';
import { SharedService } from 'src/app/services/shared/shared.service';
import { PanelPage } from '../../panel.page';
import { NewsSearchListPage } from '../news-search-list/news-search-list.page';
// import do componente não é necessário aqui, pois o template usa o seletor e o módulo já o declara/expõe

@Component({
  selector: 'app-news-dashboard',
  templateUrl: 'news-dashboard.page.html',
  styleUrls: ['news-dashboard.page.scss'],
  standalone: false,
})
export class NewsDashboard implements OnInit, OnDestroy {
  constructor(
    private readonly newsService: NewsService,
    private readonly ciService: CIService,
    private readonly router: Router,
    private readonly routeParams: ActivatedRoute,
    private readonly newSearchList: NewsSearchListPage,
    public translate: TranslateService,
    private readonly sharedService: SharedService,
    private readonly panelPage: PanelPage,
    private storage: Storage,
    private modalController: ModalController,
  ) {}

  // ID fixo da editorial "Caminhos Intencionais" no ambiente HML/PRD
  public readonly EditorialCaminhosId = 'a4acd8ee-0e95-415a-8c8e-0f406c319362';

  private filterSubject = new Subject<NewsFilterModel>();
  private readonly notifier$ = new Subject<void>();
  filter: NewsFilterModel = {
    PageIndex: 0,
    PageSize: 20,
    Search: '',
    language: this.translate.currentLang,
  };

  disabledSearch = false;
  CategoryId: CategoryModel[] = [new CategoryModel()];
  editorials: EditorialModel[] = [new EditorialModel()];
  newsHighlight: any = [];
  biggestHighlight: any;
  news: Array<Array<NewsModel>> = new Array<Array<NewsModel>>();
  newsCaminhosIntencionais: Array<NewsModel> = [];

  fakeElements = ['', '', ''];
  fakeElementsLarg = ['', '', '', '', '', ''];
  Loading = true;
  LoadingHigh = true;
  LoadingSecondary = true;
  LoadingNews = true;
  recentsLoading = false;
  empty = false;
  recentsNotFound = false;
  noCategory = false;
  refresh = false;

  async ngOnInit() {
    let cornestoneLink = this.routeParams.snapshot.queryParamMap.get('link');
    let cornestone = this.routeParams.snapshot.params['cornestone'];

    if (cornestone === 'cornestone' && cornestoneLink) {
      cornestoneLink = cornestoneLink.replace('*', '?');
      this.panelPage.gotoCornerstone(cornestoneLink);
      this.router.navigateByUrl('panel/network/home');
    }

    this.listNewsSwitch(this.filterSubject.asObservable().pipe(debounceTime(300)))
      .pipe(takeUntil(this.notifier$))
      .subscribe(async () => {
        const normalizedSearch = this.filter.Search?.trim();
        if (normalizedSearch && normalizedSearch.length > 0) {
          await this.router.navigate(['panel/network/news/news/null/null', normalizedSearch]);
          return;
        }

        await this.router.navigate(['panel/network/news/news/null/null']);
      });

    await this.refreshNews();

    // await this.checkCaminhosModal();
  }

  async checkCaminhosModal() {
    // let views = await this.storage.get('caminhosViews');
    // if (!views) {
    // }
    // if (views <= 3) {
    await this.showCaminhosModal();
    // }
  }

  async showCaminhosModal(views = 0) {
    await this.storage.set('caminhosViews', views + 1);
    const modal = await this.modalController.create({
      component: CaminhosModalComponent,
      backdropDismiss: true,
      cssClass: 'j-caminhos-modal',
    });
    await modal.present();
  }

  ngOnDestroy() {
    this.notifier$.next();
    this.notifier$.complete();

    this.filterSubject?.complete();
  }

  async refreshNews() {
    this.Loading = true;
    this.LoadingHigh = true;
    this.LoadingSecondary = true;
    this.LoadingNews = true;

    this.news = [];
    this.newsHighlight = [];
    this.newsCaminhosIntencionais = [];

    await this.getNewsHighlight();
    this.filter.Highlights = false;

    this.editorials = await lastValueFrom(this.newsService.getEditorials());
    await this.getNews();

    this.Loading = false;
    this.LoadingHigh = false;
    this.LoadingSecondary = false;
    this.LoadingNews = false;
  }

  async getNews() {
    this.filter.PageSize = 4;

    const editorialLists = await Promise.all(
      this.editorials.map(async editorial => {
        if (editorial.id === this.EditorialCaminhosId) {
          return Promise.resolve([]);
        }

        const filter = { ...this.filter, EditorialId: editorial.id };
        return lastValueFrom(this.newsService.getNews(filter));
      }),
    );

    this.news = editorialLists;

    this.filter.EditorialId = '';
    this.filter.PageSize = 6;
    this.filter.Highlights = false;

    const recentNews = await lastValueFrom(this.newsService.getNews(this.filter));
    this.news.push(recentNews);

    // Carrega as notícias do CI (Caminhos Intencionais) e mapeia para NewsModel[]
    const ciNews = (await lastValueFrom(this.ciService.getStructuredNews(4, this.translate.currentLang))) || [];
    const lang = this.translate.currentLang || 'pt';
    this.newsCaminhosIntencionais = ciNews.map(item => this.buildNewsFromStructured(item, lang));
  }

  async getNewsHighlight() {
    let filter = JSON.parse(JSON.stringify(this.filter));
    filter.Highlights = true;
    filter.Search = '';
    await lastValueFrom(this.newsService.getNews(filter)).then((res: NewsModel[]) => {
      this.newsHighlight = res;
      this.biggestHighlight = this.newsHighlight.shift(0);
      // this.biggestHighlight = this.newsHighlight[1];

      // this.newsHighlight[0].text['pt'] = '[video] loren ipsum dolor sit amet';
      // this.newsHighlight[0].title['pt'] =
      // 	'Caminhos intencionais 2033: Iniciamos a transformação do Grupo Jacto';
      // this.newsHighlight[0].internVideo = true;
      // this.newsHighlight[0].image['pt'] = '';
    });
  }

  listNewsSwitch(filter: Observable<NewsFilterModel>): Observable<NewsModel[]> {
    return filter.pipe(switchMap((filter: NewsFilterModel) => this.newsService.getNews(filter)));
  }

  addFilterChange(filter: NewsFilterModel) {
    this.filterSubject.next(filter);
  }

  search() {
    this.addFilterChange(this.filter);
  }

  async getNewsByCategory(id?: string) {
    this.recentsLoading = true;
    this.filter.CategoryId = id;
    id === null ? (this.filter.CategoryId = '') : null;

    let routerId = this.routeParams.snapshot.paramMap.get('search');

    if (routerId === 'null' || routerId === 'undefined') {
      await this.newSearchList.ionViewWillEnter();
    } else {
      await lastValueFrom(this.newsService.getNews(this.filter)).then(
        (res: NewsModel[]) => {
          if (res.length > 0) {
            this.news[4] = res;
            this.recentsLoading = false;
            this.recentsNotFound = false;
            this.empty = false;
          } else {
            this.empty = true;
            this.recentsNotFound = false;
            this.recentsLoading = false;
          }
        },
        () => {
          this.recentsLoading = false;
          this.empty = false;
          this.recentsNotFound = true;
        },
      );
    }
    id === null ? (this.filter.CategoryId = 'null') : null;
  }

  /**
   * Constrói um NewsModel a partir do item estruturado retornado pelo CIService
   */
  private buildNewsFromStructured(item: CIStructuredNewsModel, lang: string): NewsModel {
    const n = new NewsModel();
    n.id = item?.id || '';

    // Preenche título no idioma atual
    n.title = n.title || ({} as any);
    (n.title as any)[lang] = item?.title || '';

    // Preenche imagem/video
    if (item.mediaType === 'video') {
      n.video[lang] = item?.imageUrl || '';
    } else {
      n.image[lang] = item?.imageUrl || '';
    }

    // Datas
    if (item?.createdAt) {
      try {
        n.creationDate = new Date(item.createdAt);
      } catch {}
    }

    n.redirectLink = item.redirectPath || '';

    // Demais campos default
    n.internVideo = '';
    n.Likes = 0;

    return n;
  }
}
